/* eslint-disable max-len */
import React, { useEffect } from "react";
import {
  useCombinedAlertsDataStore,
  useWellnessRenewalFunnel,
} from "../../hooks";

import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { WELLNESS_RENEWAL_ENTRY_POINTS } from "../../config/params";
import WellnessRenewalPetAvatars from "../PetAvatars/WellnessRenewalPetAvatars";
import { formattedWellnessRenewalPetNames } from "../../utils/genericUtils";
import { userActivityLogger } from "../../utils/mixpanel";

const WellnessRenewalDashboardCard = () => {
  const { endsSoonWPData } = useCombinedAlertsDataStore();
  const { startRenewalFunnel } = useWellnessRenewalFunnel();

  const petData = endsSoonWPData;
  const petNames = formattedWellnessRenewalPetNames(petData.map((p) => p.petName));
  const namePrefix = petNames ? `${petNames}'s` : "Your pets'";
  const title = "TotalCare Plan Renewal";
  const description = `${namePrefix} TotalCare options might look a little different this year. Keep their care plan on track by reviewing your options today.`;
  const buttonText = "See Your Options";

  const handleReviewPlans = () => {
    startRenewalFunnel(
      petData,
      WELLNESS_RENEWAL_ENTRY_POINTS.DASHBOARD_RENEWAL_CARD,
    );
  };

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.DASHBOARD_RENEWAL_CARD_SHOWN, {
      pet_name: petData?.length > 0 ? petData[0].petName : "",
      plan_name: petData?.length > 0 ? petData[0].wellnessPlanName : "",
      number_of_pets: petData?.length || 0,
    });
  }, []);

  return (
    <div className="medium:py-6 medium:px-4 bg-violet-6 p-4 rounded-lg">
      <div className="rounded-xl bg-white p-4 flex flex-col gap-2 relative">
        <div className="flex gap-4">
          <div className="shrink-0">
            <WellnessRenewalPetAvatars
              petDetails={petData}
              defaultWellnessStatus={true}
              width={80}
              height={80}
            />
          </div>
          <div className="flex flex-col justify-center self-center gap-1">
            <div className="!text-base font-semibold">{title}</div>
            <div className="!text-xs font-normal grow">
              {description}
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div
            className="text-xs text-center w-full bg-violet-3
          p-2 rounded-2xl font-semibold hover:bg-gray-3 cursor-pointer"
            onClick={handleReviewPlans}
          >
            {buttonText}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WellnessRenewalDashboardCard;
